import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
// import { GMap } from 'primeng/gmap';
import { MapOptionsShared } from '../../../models/interface/mapOptions.interface';
import { MuMapLeafletComponent } from '../mu-map-leaflet/mu-map-leaflet.component';
import { AtlasType } from './interfaces/mu-atlas-types.interface';
import { MuMapAtlasService } from './services/mu-map-atlas.service';
import { MuMapLeafletFactory } from '../mu-map-leaflet/mu-map-leaflet.factory';
import { AtlasMap } from './interfaces/mu-atlas-map.interface';
import { MuMapLegacyFactory } from './legacy/mu-map-legacy.factory';
import { AtlasMarker } from './interfaces/mu-atlas-marker.interface';

@Component({
  selector: 'app-mu-atlas',
  templateUrl: './mu-atlas.component.html',
  styleUrls: ['./mu-atlas.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MuAtlasComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {
  // Set the type of map for using. Google by default
  @Input() set mapType(value: string) {
    if (value.toLowerCase() === 'leaflet') {
      this._mapType = AtlasType.LEAFLET;
    } else {
      this._mapType = AtlasType.GOOGLE;
    }
  }

  // General options for map as center, zoom, style and so on
  @Input() options: MapOptionsShared;

  // Array of map elements like Polygon and Markers
  @Input() overlays: any[];MapOptions

  // When map component is created, return map element (Map Interface)
// eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onMapReady: EventEmitter<any> = new EventEmitter();

  // Reference to container element to insert the map
  @ViewChild('mumap', { read: ViewContainerRef, static: true }) mapContainer!: ViewContainerRef;

  // Internal reference of map component
  private _mapComponent: ComponentRef<AtlasMap>;

  // Type of map, by default is Google
  private _mapType: AtlasType = AtlasType.GOOGLE;

  // Differ to identify changes on overlays input
  private differ: IterableDiffer<any>;

  constructor(private muMapAtlasService: MuMapAtlasService, private cd: ChangeDetectorRef, private differs: IterableDiffers) {
    this.differ = differs.find([]).create();
  }

  ngOnInit() {
    this.mapContainer.clear();

    if (this._mapType === AtlasType.LEAFLET) {
      this._mapComponent = this.mapContainer.createComponent<AtlasMap>(MuMapLeafletComponent);
      this.muMapAtlasService.setFactory(new MuMapLeafletFactory());
    } else {
      this._mapComponent = this.mapContainer.createComponent<AtlasMap>(MuMapLeafletComponent) as unknown as ComponentRef<AtlasMap>;
      this.muMapAtlasService.setFactory(new MuMapLegacyFactory());
    }

    this._mapComponent.instance.options = this.options;
    this._mapComponent.instance.overlays = this.overlays;
  }

  ngAfterViewInit() {
    let mapInstance: AtlasMap = this._mapComponent.instance;

    // Only for compatibility. Google map object is modified to comply with AtlasMap interface
    if (this._mapType === AtlasType.GOOGLE) {
      mapInstance = (mapInstance as any).map;
    }
    if(mapInstance){
      this.onMapReady.emit(mapInstance);
    }
  }

  ngDoCheck() {
    if (this.differ.diff(this.overlays)) {
      this._mapComponent?.setInput('overlays', this.overlays);
      this.cd.markForCheck();
    }
  }

  ngOnDestroy(): void {
    this._mapComponent.destroy();
  }
}
